import { useRef, useState, useEffect, useCallback } from "react";
// Importacion de las imagenes utilizadas para la brujula
import relojBase from "../../img/domo/Picture7.png";
import grua from "../../img/domo/grua.png";
// Importacion de lo estilos css
import "./AnimationDomo.css";

/**
 *
 * @returns
 */
export default function AnimationDomo({ position = 0 }) {
  const [deg, setDeg] = useState(0);
  const [isCompassMoving] = useState(true);

  const [positionTest, setPosition] = useState(0);

  const manesilla = useRef(0);

  /**
   *
   */
  const handleCompassMove = useCallback((e) => {
    const w = window.innerWidth / 2;
    const h = window.innerHeight / 2;

    const x = e.clientX;
    const y = e.clientY;

    const deltaX = w - x;
    const deltaY = h - y;

    const rad = Math.atan2(deltaY, deltaX);
    let deg = Math.round(rad * (180 / Math.PI));

    if (deg < 0) {
      deg = (deg + 360) % 360;
    }

    setDeg(deg);

    manesilla.current.style.transform = "rotate(" + deg + "deg)";
  }, []);

  /**
   *
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSetPosition = useCallback((e) => {
    const position = e.target.value;
    manesilla.current.style.transform = "rotate(" + position + "deg)";
  });

  /*
  useEffect(() => {
    setTimeout(() => {
      if (manesilla.current !== null) {
        manesilla.current.style.transform = "rotate(" + positionTest + "deg)";
        if (positionTest === 360) {
          setPosition(0);
        } else {
          setPosition(positionTest + 20);
        }
      }
    }, 2000);
  }, [positionTest]);
  */

  useEffect(() => {
    if (manesilla.current === null) {
      return;
    }

    manesilla.current.style.transform = "rotate(" + position + "deg)";
  }, [position]);

  /*
  useEffect(() => {
    if (isCompassMoving) {
      window.addEventListener("mousemove", handleCompassMove);
    } else {
      window.removeEventListener("mousemove", handleCompassMove);
    }
    return () => window.removeEventListener("mousemove", handleCompassMove);
  }, [isCompassMoving, handleCompassMove]);
  */

  return (
    <>
      <div className="container">
        <div className="main-reloj">
          <img id="relojBase" src={relojBase} alt="reloj-base" />
          <img
            id="lineaBase"
            className="line"
            ref={manesilla}
            src={grua}
            alt="manesilla"
          />
        </div>
      </div>
    </>
  );
}
